import { render, staticRenderFns } from "./TradingOperation.vue?vue&type=template&id=616979a1&scoped=true"
import script from "./TradingOperation.vue?vue&type=script&lang=js"
export * from "./TradingOperation.vue?vue&type=script&lang=js"
import style0 from "./TradingOperation.vue?vue&type=style&index=0&id=616979a1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616979a1",
  null
  
)

export default component.exports